module.exports = __webpack_public_path__ + "static/img/49.b72fba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/49.png
// module id = 16Ge
// module chunks = 0